// import objectAssign from "object-assign";
import HTTP from "../Http";
import { config } from "../config";
class SDK {
  private config: {
    origin: string;
  };
  constructor(options: { origin: string }) {
    this.config = options;
  }

  public weChatShare = async (params: any) => {
    return await HTTP.postJson({
      url: `${this.config.origin}/live/api/weChat/share`,
      params
    });
  };

  public wxWorkweChatShare = async (params: { pageUrl: string; sourceType: number }) => {
    return await HTTP.getNotWithCredentials({
      url: `//cloud.xylink.com/sfqywx/wxCp/?pageUrl=${params.pageUrl}&sourceType=${
        params.sourceType
      }`
    });
  };

  public getInitData = async (liveId: string, securityKey?: string) => {
    let params = {};
    if (!!securityKey) {
      params = Object.assign({}, { securityKey });
    }
    return await HTTP.get({
      url: `${this.config.origin}/live/watch/${liveId}/info`,
      params
    });
  };

  public putAudience = async (liveId: string, params: any) => {
    return await HTTP.put({
      url: `${this.config.origin}/live/watch/${liveId}/audience`,
      params
    });
  };

  public postNotChatRoomIdError = async () => {
    return await HTTP.postTest({
      url: `${this.config.origin}/live/v/notify/chatroom/error`
    });
  };

  public getHeartbeat = async (
    liveId: string,
    videoType: string,
    randomStr: string,
    upvoteCount: number
  ) => {
    return await HTTP.get({
      url: `${this.config.origin}/live/watch/${liveId}/heartbeat`,
      params: {
        videoType,
        randomStr,
        haveVideoSrc: "none",
        upvoteCount
      }
    });
  };

  public putHeartbeat = async (
    liveId: string,
    videoType: string,
    randomStr: string,
    upvoteCount: number
  ) => {
    return await HTTP.put({
      url: `${this.config.origin}/live/watch/${liveId}/heartbeat`,
      params: {
        videoType,
        randomStr,
        haveVideoSrc: "none",
        upvoteCount
      }
    });
  };

  public userIsPay = async () => {
    return await HTTP.get({
      url: `${this.config.origin}/live/vpay/check`
    });
  };

  public getAudience = async (liveId: string, videoType: string, randomStr: string) => {
    return await HTTP.get({
      url: `${this.config.origin}/live/watch/${liveId}/audience`,
      params: {
        videoType,
        randomStr
      }
    });
  };

  public getVoteInfo = async (voteId: string) => {
    return await HTTP.get({
      url: `${this.config.origin}/live/rest/vote/questionnaire/${voteId}`
    });
  };

  public postSubmitVote = async (params: any) => {
    return await HTTP.postJson({
      url: `${this.config.origin}/live/rest/vote/replies`,
      params
    });
  };

  public onJoinLive = async (liveId: string) => {
    return await HTTP.get({
      url: `${this.config.origin}/live/liveVideo/all/check4start/${liveId}`
    });
  };

  public resultVote = async (voteId: string) => {
    return await HTTP.get({
      url: `${this.config.origin}/live/rest/vote/statistics/${voteId}`
    });
  };

  public TESTInsideAndOutsideNet = async (src: string) => {
    return await HTTP.HEADTimeOut(`${src}`, {
      timeout: 1000
    });
  };

  // public onloadBye = (liveId: string) => {
  //   HTTP.postJson({
  //     url: `${this.config.origin}/live/watch/${liveId}/bye`
  //   });
  // };
}

export default new SDK({ origin: config.path });



// WEBPACK FOOTER //
// ./src/publics/sdk/index.ts